import { Biscuit } from "../utils";
// @ts-ignore
import { getContentModifications } from "../App";
import ContingentsControllerAccessBarMap from "../controllers/ContingentsControllerAccessBarMap";
import t from "../react/helpers/t";
import {getApiHost} from "../Sync";
import * as FileSaver from "../../vendor/FileSaver";
import showNotification from "../react/helpers/showNotification";
import { Typography } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import * as XLSX from "xlsx";


export const in_array: (needle: string, haystack: any) => boolean = (
  needle: string,
  haystack: any,
): boolean => {
  for (let i: number = 0, len: number = haystack.length; i < len; i++) {
    if (haystack[i] === needle) return true;
  }
  return false;
};

export const isValidUrl: (urlString: string) => boolean = (urlString: string): boolean => {
  let urlPattern: RegExp = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i",
  ); // validate fragment locator
  return urlPattern.test(urlString);
};

export const getFilterData: (datas: any, summaryPending: boolean, summary: any) => any[] = (datas: any, summaryPending: boolean, summary: any): any[] => {
    let newData: any[] = [];
    datas.map((data: any): void => {
        if (typeof data.summaryItem === 'undefined') {
            data.summaryItem = data.value;
        }
        newData.push(
            {
                name: data.name + (!summaryPending && summary !== null && typeof summary[data.summaryItem] !== 'undefined' ? ' (' + summary[data.summaryItem] + ')' : ''),
                value: data.value,
                dataKey: 'state_' + data.value
            }
        )
    });
    return newData;
}

export const jsonToBase64: (object: any) => string = (object: any): string => {
  return encodeURIComponent(JSON.stringify(object));
};

const printResult: (result: any) => Promise<any> = async (result: any): Promise<any> => {
  return await result;
};

export const base64ToJson: (base64String: string) => any = (base64String: string): any => {
  return JSON.parse(decodeURIComponent(base64String));
};

export const encode_utf8: (s: any) => Uint8Array<ArrayBuffer> = (
  s: any,
): Uint8Array<ArrayBuffer> => {
  // @ts-ignore
  const encoder = new TextEncoder("utf-8");
  return encoder.encode(s);
};

export const decode_utf8: (s: any) => void = (s: any): void => {
  const decoder = new TextDecoder("utf-8");
  decoder.decode(s);
};

export const setItem: (label: string, item: any, json?: boolean) => void = (
  label: string,
  item: string | any,
  json: boolean = false,
): void => {
  if (json) {
    Biscuit.set(label, JSON.stringify(item));
  } else {
    Biscuit.set(label, item);
  }
};

export const getItem: (label: string, json?: boolean) => any = (
  label: string,
  json: boolean = false,
): null | any => {
  if (json) {
    let val = Biscuit.get(label);
    if (val === "") {
      return null;
    }
    return JSON.parse(val);
  }
  return Biscuit.get(label);
};

export const _getObjectFromArray: (array: any) => any = (array: any): any => {
  return array.reduce((obj: any, entity: any): any => {
    obj[entity.id] = entity;
    return obj;
  }, {});
};

export const _exchangeLabel: (value: string) => string = (value: string): string => {
  let cm: any = getContentModifications();
  if (cm.labels != null) {
    if (cm.labels[value] !== undefined) {
      return cm.labels[value];
    }
  }
  return value;
};

type ItemType = {
  name: string;
  link: string;
  data_inb_val: string;
  icon: string;
  isActive: boolean;
  isAccessible: boolean;
};
export const createSubmenuItems: (it: number | string) => ItemType[] = (
  it: number | string,
): ItemType[] => {
  const contingentsMap: any = ContingentsControllerAccessBarMap();
  const items: any = [];

  for (let i in contingentsMap) {
    let item: ItemType = {
      name: t(_exchangeLabel(i), null, "capital"),
      link: contingentsMap[i].url,
      data_inb_val: i,
      icon: contingentsMap[i].icon,
      isActive: i === it,
      isAccessible: contingentsMap[i].isAccessible,
    };
    items.push(item);
  }
  return items;
};

/*
   - url the url (without API HOST) for request
   - method can be GET, POST, PUT, PATCH, DELETE
   - type at Example id of Resource etc.
   - filename the result filename
   - notification error message if a error occurs
 */
export const getDocHandler: (
  url: string,
  method: string,
  type: string,
  filename: string,
  notification: string,
  id?: string | null,
  body?: any,
  publicSet?: boolean,
  invoice?: boolean,
  convertToCSV?: boolean,
  returnResult?: boolean,
  returnBlob?: (blob: Blob) => void,
) => void | boolean = (
  url: string,
  method: string,
  type: string,
  filename: string,
  notification: string,
  id: string | null = null,
  body: any | null = null,
  publicSet: boolean = false,
  invoice: boolean = false,
  convertToCSV: boolean = false,
  returnResult: boolean = false,
  returnBlob: ((blob: Blob) => void) | undefined = undefined,
): void | boolean => {
  const xmlHttp = new XMLHttpRequest();
  console.log(getApiHost(publicSet, invoice) + url, "publicSet");
  xmlHttp.open(method, getApiHost(publicSet, invoice) + url, true);
  xmlHttp.setRequestHeader("Accept", "application/json");
  if (in_array(method, ["POST", "PUT", "PATCH"]) && body !== null) {
    xmlHttp.setRequestHeader("Content-Type", "application/json");
  }
  xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));

  xmlHttp.responseType = "blob";

  xmlHttp.onerror = function () {};

  xmlHttp.onload = function (): void {
    if (xmlHttp.status === 500 || xmlHttp.status === 400) {
      showNotification("warning", id, notification);
      return;
    }

    if (
      xmlHttp.status === 404 ||
      (typeof xmlHttp.response.size !== "undefined" && xmlHttp.response.size === 13)
    ) {
      showNotification("warning", id, notification);
      return;
    }

    let blob = new Blob([xmlHttp.response], { type: type });
    if (convertToCSV) {
      let dataToSheet = XLSX.utils.json_to_sheet(xmlHttp.response.data);
      // @ts-ignore
      const dataFileCSV = XLSX.utils.sheet_to_csv(dataToSheet,{ raw: false, defval: null },{ FS: ";" },);
      blob = new Blob(["\ufeff", dataFileCSV]);
      //let fileBlob = new File([blob], "name");
    }
    // Unfortunately, xmlHttp.getResponseHeader('Content-Disposition'); is null so we have to
    // re-create the file name
    
    if (returnBlob) return returnBlob(blob);
    showFile(blob, filename);
  };
  if (in_array(method, ["POST", "PUT", "PATCH"]) && body !== null) {
    xmlHttp.send(JSON.stringify(body));
  } else {
    xmlHttp.send(null);
  }
  if (returnResult) {
    return true;
  }
};

export const showFile: (blob: Blob, filename: string) => void = (
  blob: Blob,
  filename: string,
): void => {
  FileSaver.saveAs(blob, filename);
}
export const checkAndParseJson: (obj: any) => string | undefined = (obj: any | null | string): string | undefined => {
  if (obj === null) {
    return "";
  }
  if (typeof obj === "string") {
    if (
      (obj.substring(0, 1) === "{" && obj.substring(obj.length - 1) === "}") ||
      (obj.substring(0, 1) === "[" && obj.substring(obj.length - 1) === "]")
    ) {
      try {
        let values = JSON.parse(obj);
        let returnString = "";
        if (typeof values[0] !== "undefined") {
          let possible = [];
          for (let i = 0; i < values.length; i++) {
            if (values[i]?.valueSelect !== null) {
              possible.push({
                question: values[i].question,
                answer: values[i].valueSelect,
              });
            }
          }
          if (possible.length > 0) {
            possible.map((q: { question: string; answer: string }): void => {
              returnString += q.question + "::" + q.answer + "//";
            });
          }
          return returnString;
        } else {
          return "";
        }
      } catch {
        return "";
      }
    } else {
      if (obj.substring(0, 1) === "{" || obj.substring(0, 1) === "[") {
        //broken json
        return "";
      }
      return obj;
    }
  }
};

export const showPopUp: (type: string, name: string) => boolean = (
  type: string,
  name: string,
): boolean => {
  let output =
    `
          <html>
            <head>
                <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">
                <title>` +
    t("info", null, "capital") +
    `</title>
                <style type="text/css">
                    body { font-family: "Open Sans",Helvetica,Arial,sans-serif;background-color: white; }
                    hode, html, table, thead { width: 100%; }
                    h4 { font-size: 18px; }
                    .printSpacer { height:100px; }
                </style>
                </head>
            <div>` +
    (type === "InfoString" ? t(name + "_info") : name) +
    `
            </body>
            </html>`;
  let rV: number = -1; // Return value assumes failure.

  if (navigator.appName == "Microsoft Internet Explorer" || navigator.appName == "Netscape") {
    let uA: string = navigator.userAgent;
    let rE: RegExp = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

    if (rE.exec(uA) != null) {
      rV = parseFloat(RegExp.$1);
    } else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      rV = 11;
    }
  }

  const isChrome: boolean =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  const newWindow: Window | null = window.open("", "", "height=700,width=674");
  if (newWindow === null) {
    return false;
  }
  newWindow.document.body.innerHTML = "";
  newWindow.document.body.innerHTML = output;
  if (rV >= 10 || isChrome) {
    newWindow.focus(); // necessary for IE >= 10*
  } else {
    // e.g. Firefox
    setTimeout((): void => {
      newWindow.opener.focus();
    }, 0);
  }
  return true;
};

/*const ToBeStyledTooltip = ({ className, ...props }:TooltipProps) => (
    <Tooltip title={""} className={className} children={<> </>} classes={{ tooltip: className }} />
);

export const HtmlTooltip = styled(ToBeStyledTooltip)(({ theme }) => ({
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9"
}));*/

export const HtmlTooltip = styled(Tooltip)<TooltipProps>(({ theme }) => ({
  backgroundColor: "#f5f5f9",
  color: "rgba(0, 0, 0, 0.87)",
  maxWidth: 400,
  fontSize: theme.typography.pxToRem(12),
  border: "1px solid #dadde9",
}));
// @ts-ignore
/*export const HtmlTooltip = styled(({className, ...props}: TooltipProps) => (
    // @ts-ignore
    <Tooltip title={""} {...props} classes={{popper: className}}/>
))(({theme}) => ({
        backgroundColor: "#f5f5f9",
        color: "rgba(0, 0, 0, 0.87)",
        maxWidth: 400,
        fontSize: theme.typography.pxToRem(12),
        border: "1px solid #dadde9"
    }
));*/

interface ADJUSTMENT_HELP_TEXTProps {
  content?: unknown;
}

export const ADJUSTMENT_HELP_TEXT = styled(
  ({
    className,
    ...props
  }: {
    className: string;
    props: ADJUSTMENT_HELP_TEXTProps;
  }): React.JSX.Element => (
    <Typography component="div" fontSize="0.8rem">
      {
        // @ts-ignore
        props.content.split("//").map((q: any, index: any) => {
          // @ts-ignore
          let length: number = props.content.split("//").length;
          /*returnString += '<p style="font-weight:bold;">' + q.question + "</p>";
                returnString += "<p>" + q.answer + "</p></br>";*/
          if (q !== "") {
            let str: any = q.split("::");
            let color: any = {};
            if (typeof str[1] === "undefined") {
              str[1] = "";
            }
            if (str[1].substring(0, 5) === "ALERT") {
              color = { color: "red" };
              str[1] = str[1].substring(5);
            }
            if (str[1].substring(0, 4) === "LIST") {
              str[1] = str[1].substring(4);
              let strA = str[1].split("<li>");
              return (
                <>
                  <Typography color="inherit" fontSize="0.8rem">
                    {str[0]}
                  </Typography>
                  <ul>
                    {strA.map((li: any): React.JSX.Element => {
                      return <li>{li}</li>;
                    })}
                  </ul>
                </>
              );
            }
            return (
              <>
                <Typography
                  color="inherit"
                  fontWeight="bold"
                  paddingTop={index > 0 ? "0px" : "0px"}
                  fontSize="0.8rem"
                  lineHeight="1"
                >
                  {str[0]}
                </Typography>
                <em style={color}>{str[1]}</em>
                {length > index + 1 ? (
                  <hr
                    style={{ height: "8px", padding: "0", marginTop: "4px", marginBottom: "4px" }}
                  />
                ) : (
                  ""
                )}
              </>
            );
          }
        })
      }
    </Typography>
  ),
)();

export const getUserString: (user: any) => string = (user: any): string => {
  let userString: string = "";
  if (user === null) {
    userString = t("unknown");
  } else {
    if (user?.first_name !== "" && user?.first_name !== null) {
      userString += user?.first_name + " ";
    }
    if (user?.last_name !== "" && user?.last_name !== null) {
      userString += user?.last_name;
    }
    if (userString === "" && user?.username !== "" && user?.username !== null) {
      userString += user?.username;
    }
    if (userString === "" && user?.id !== null) {
      userString += user?.id;
    }
  }
  return userString;
};

export function containsNumbers(str: string): boolean {
  return /\d/.test(str);
}

export const getDuration: (
  duration: number | null,
  onlyAmount?: boolean,
  onlyUnit?: boolean,
  nullAble?: boolean,
) => number | null | string = (
  duration: number | null,
  onlyAmount: boolean = false,
  onlyUnit: boolean = false,
  nullAble: boolean = false,
): number | null | string => {
  let unit: string = "hour";
  let val: number = 1;
  if (duration !== null) {
    if (duration < 3600 && onlyAmount) {
      return duration;
    }
    if (duration > 3600) {
      unit = "hours";
      val = duration / 3600;
      if (duration == 86400) {
        unit = "day";
        val = 1;
      }
      if (duration > 86400) {
        if (Number.isInteger(duration / 86400)) {
          unit = "days";
          val = duration / 86400;
        }
        if (duration == 7 * 86400) {
          unit = "week";
          val = 1;
        }
        if (duration > 7 * 86400) {
          if (Number.isInteger(duration / (7 * 86400))) {
            unit = "weeks";
            val = duration / (7 * 86400);
          }
          if (duration == 30 * 86400) {
            unit = "month";
            val = 1;
          }
          if (duration > 30 * 86400) {
            if (Number.isInteger(duration / (30 * 86400))) {
              unit = "months";
              val = duration / (30 * 86400);
            }
            if (duration == 365 * 86400) {
              unit = "year";
              val = 1;
            }
            console.log(duration);
            console.log(365 * 86400);
            if (duration > 365 * 86400) {
              if (Number.isInteger(duration / (365 * 86400))) {
                unit = "years";
                val = duration / (365 * 86400);
              }
            }
          }
        }
      }
    }
  }
  if (onlyAmount) {
    return nullAble && duration === null ? null : val;
  }
  if (onlyUnit) {
    return nullAble && duration === null ? null : unit;
  }
  return nullAble && duration === null ? null : val + " " + t(unit);
};

export const getDurationReverse: (durationAmount: number, durationUnit: string) => number = (
  durationAmount: number,
  durationUnit: string,
): number => {
  let unit: number = 0;
  switch (durationUnit) {
    case "hour":
      unit = 60;
      break;
    case "hours":
      unit = 60;
      break;
    case "day":
      unit = 86400;
      break;
    case "days":
      unit = 86400;
      break;
    case "week":
      unit = 7 * 86400;
      break;
    case "weeks":
      unit = 7 * 86400;
      break;
    case "month":
      unit = 30 * 86400;
      break;
    case "months":
      unit = 30 * 86400;
      break;
    case "year":
      unit = 365 * 86400;
      break;
    case "years":
      unit = 365 * 86400;
      break;
  }
  return durationAmount * unit;
};

export const strstr: (haystack: string, needle: string, bool: boolean) => string | boolean = (
  haystack: string,
  needle: string,
  bool: boolean,
): string | boolean => {
  // Finds first occurrence of a string within another
  //
  // version: 1103.1210
  // discuss at: http://phpjs.org/functions/strstr    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +   bugfixed by: Onno Marsman
  // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // *     example 1: strstr(‘Kevin van Zonneveld’, ‘van’);
  // *     returns 1: ‘van Zonneveld’    // *     example 2: strstr(‘Kevin van Zonneveld’, ‘van’, true);
  // *     returns 2: ‘Kevin ‘
  // *     example 3: strstr(‘name@example.com’, ‘@’);
  // *     returns 3: ‘@example.com’
  // *     example 4: strstr(‘name@example.com’, ‘@’, true);    // *     returns 4: ‘name’
  let pos: number = 0;

  haystack += "";
  pos = haystack.indexOf(needle);
  if (pos == -1) {
    return false;
  } else {
    if (bool) {
      return haystack.substr(0, pos);
    } else {
      return haystack.slice(pos);
    }
  }
};
